import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApiService } from './api/api.service';
import { selectAuthStatus } from './store/auth/auth.reducer';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'fe-fishmaster';
  constructor(private state: Store, private api: ApiService) {
    this.state.select(selectAuthStatus).subscribe((status) => {
      if (status === 'authorized') {
        this.api.getMainState();
      }
    });
  }
}
